import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
import BackHeader from "../../../components/BackHeader/BackHeader";
import { GlobalContextType } from "../../../@types/global";
import { GlobalContext } from "../../../context/globalContext";
import {
  Select,
  Space,
  Form,
  Table,
  Button,
  Collapse,
  Tabs,
  Row,
  Col,
  Descriptions,
  Tooltip,
  Tag,
  Alert,
  Popconfirm,
  Card,
  Progress,
  Statistic,
} from "antd";
import {
  CheckCircleOutlined,
  EyeOutlined,
  PrinterOutlined,
  RightOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { AreaType } from "../../../context/processosContext";
import { Danger } from "iconsax-react";
import { Questionario } from "../../../context/mapeamentoContext";
import { Titular } from "../../../@types/titular";
import TimelineGeral from "../../../components/Timeline/TimelineGeral";
import ContainerFicha from "./components/ContainerFicha/ContainerFicha";
import PdfDownload from "../../../components/PdfDownload/PdfDownload";
import RelatorioROT from "./components/RelatorioROT/RelatorioROT";
import Task from "../../../components/Tarefas/Task/Task";

interface Filtros {
  cliente?: string;
  mapeamento?: string;
  area?: string;
  processo?: string;
  subprocesso?: string;
}

interface FichasProps {
  filtrosFeitos?: Filtros;
  backHeaderFunction?: VoidFunction;
}

interface NotasPorItem {
  [key: string]: number;
}

interface AnaliseRiscoState {
  [key: string]: {
    titular: any;
    analiseRiscoTitular: {
      pontuacaoTotal: number;
      quantidadeFatores: number;
      risco: number;
      nivelRisco: string;
      notasPorItem: NotasPorItem;
    };
    questionario: {
      id: string;
      nome: string;
    };
    capitulo: {
      id: string;
      nome: string;
    };
    areas: Array<{
      id: string;
      nome: string;
    }>;
    versoesRespostas: Array<{
      id: string;
      status: string;
      created_at: string;
      updated_at: string;
      prazo: string;
      respostas: Array<any>;
    }>;
    analiseRespostasQuestionario: {
      totalRespostas: number;
      somaNotas: number;
      media: number;
      notasPorResposta: Array<{
        resposta: string;
        nota: number;
      }>;
    };
  };
}

const Fichas = ({
  filtrosFeitos,
  backHeaderFunction,
}: FichasProps): JSX.Element => {
  const {
    clientes,
    moduloProcessos,
    moduloMapeamento,
    usuarios,
    fornecedores,
    getFornecedores,
    fetchClienteLogs,
    moduloTask,
    currentCliente,
  } = React.useContext(GlobalContext) as GlobalContextType;

  const [form] = Form.useForm(); // Adicionei a declaração do form
  const printRef = useRef<HTMLDivElement>(null);

  const [filtros, setFiltros] = useState<any>(null);
  const [activeKey, setActiveKey] = useState<string>("1");
  const [logs, setLogs] = useState<any[] | null>(null);
  const [loadingLogs, setLoadingLogs] = useState<boolean>(true);
  const [showModal, setShowModal] = useState<boolean>(false);

  const [currentMapeamento, setCurrentMapeamento] = useState<
    Questionario | null | undefined
  >(null);

  const [analiseRisco, setAnaliseRisco] = useState<AnaliseRiscoState>({});

  useEffect(() => {
    if (currentCliente?._id) {
      moduloTask?.fetchClienteTasks(currentCliente._id);
    }
  }, [currentCliente]);

  useEffect(() => {
    if (filtros?.cliente) {
      if (
        !moduloMapeamento?.questionarios?.find(
          (q) => q.cliente_id === filtros?.cliente
        ) &&
        clientes?.filter((c: any) => c._id === filtros?.cliente)?.[0]
          ?.razao_social
      ) {
        moduloMapeamento.getQuestionariosCliente(filtros?.cliente);
      }
    }
  }, [filtros?.cliente]);

  useEffect(() => {
    if (filtros?.mapeamento && !currentMapeamento) {
      setCurrentMapeamento(
        moduloMapeamento.questionarios?.find(
          (q) => q._id === filtros.mapeamento
        )
      );
    }
  }, [filtros?.mapeamento]);

  useEffect(() => {
    if (currentCliente?._id && !filtrosFeitos) {
      setFiltros({
        cliente: currentCliente?._id,
      });
    }

    if (currentCliente?._id) {
      moduloMapeamento?.getTitulares(currentCliente?._id);
    }
  }, [currentCliente]);

  useEffect(() => {
    if (filtrosFeitos?.cliente || filtros?.cliente) {
      if (filtrosFeitos?.cliente && !filtros?.cliente) {
        setFiltros(filtrosFeitos);
      }
    }
  }, [filtrosFeitos]);

  useEffect(() => {
    if (currentCliente?._id) {
      fetchClienteLogs(currentCliente._id)
        .then((r) => setLogs(r))
        .finally(() => setLoadingLogs(false));

      !fornecedores?.[0] && getFornecedores(currentCliente._id);
    }
  }, [currentCliente]);
  const handleShowModal = () => {
    showModal ? setShowModal(false) : setShowModal(true);
  };
  useEffect(() => {
    if (clientes?.length === 1 && !filtros?.cliente && !filtrosFeitos) {
      setFiltros((prev: any) => ({
        ...prev,
        cliente: clientes[0]?._id,
      }));
    }
  }, [clientes]);

  useEffect(() => {
    if (
      moduloMapeamento.questionarios?.filter(
        (quest: any) => quest.nome === "Assessment Process"
      )?.length === 1 &&
      !filtros?.mapeamento &&
      !filtrosFeitos
    ) {
      let mapeamentoAtual = moduloMapeamento.questionarios?.filter(
        (quest: any) => quest.nome === "Assessment Process"
      )?.[0];

      setFiltros((prev: any) => ({
        ...prev,
        cliente: mapeamentoAtual?.cliente_id,
        mapeamento: mapeamentoAtual?._id,
      }));

      setCurrentMapeamento(mapeamentoAtual);

      if (
        mapeamentoAtual.capitulos?.filter((proc: any) => !proc.dependencia)
          ?.length === 1
      ) {
        let filtro = {
          cliente: mapeamentoAtual?.cliente_id,
          mapeamento: mapeamentoAtual?._id,
          area: mapeamentoAtual.capitulos?.find(
            (proc: any) => !proc.dependencia
          )?.areas_id?.[0],
          processo: mapeamentoAtual.capitulos?.find(
            (proc: any) => !proc.dependencia
          )?._id,
        };

        if (
          mapeamentoAtual.capitulos?.filter((proc: any) => proc.dependencia)
            ?.length === 1
        ) {
          setFiltros({
            ...filtro,
            subprocesso: mapeamentoAtual.capitulos?.find(
              (proc: any) => proc.dependencia
            )?._id,
          });
        } else {
          setFiltros(filtro);
        }
      }
    }
  }, [moduloMapeamento.questionarios]);

  useEffect(() => {
    if (
      (moduloProcessos?.areas?.length === 1 ||
        currentMapeamento?.areas?.length === 1) &&
      !filtros?.area &&
      !filtrosFeitos
    ) {
      setFiltros((prev: any) => ({
        ...prev,
        area: moduloProcessos?.areas?.[0]._id,
      }));
    }
  }, [moduloProcessos.areas, currentMapeamento]);

  useEffect(() => {
    const fetchAnaliseRisco = async () => {
      const processos = currentMapeamento?.capitulos?.find(
        (processo: any) =>
          processo?._id ===
          (filtros?.subprocesso ? filtros?.subprocesso : filtros?.processo)
      );

      const titulares = moduloMapeamento?.currentTitulares?.filter(
        (titular) => titular.relacao_id === processos?.questionarioCapitulo?._id
      );

      if (titulares && titulares.length > 0) {
        for (const titular of titulares) {
          if (titular._id) {
            const titularId = String(titular._id);
            try {
              const response = await moduloMapeamento.getAnaliseRiscoTitular(
                titularId
              );
              setAnaliseRisco((prev) => ({
                ...prev,
                [titularId]: response,
              }));
            } catch (error) {
              console.error("Erro ao buscar análise de risco:", error);
            }
          }
        }
      }
    };

    fetchAnaliseRisco();
  }, [
    filtros?.processo,
    filtros?.subprocesso,
    currentMapeamento,
    moduloMapeamento?.currentTitulares,
  ]);
  const columns = [
    {
      title: "Título",
      dataIndex: "title",
      key: "title",
      render: (text: string, record: any) => {
        return (
          <Tooltip title={text}>
            <span
              onClick={() => console.log(record)}
              style={{
                fontSize: "12px",
                textDecorationLine:
                  record.status === "Concluída" ? "line-through" : "none",
              }}
            >
              {text}
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: "Atribuição",
      dataIndex: "assignment_id",
      key: "assignment_id",
      render: (assignmentId: string) => (
        <span style={{ fontSize: "12px" }}>
          {usuarios?.find((u: any) => u._id === assignmentId)?.name}
        </span>
      ),
    },
    {
      title: "Prazo",
      dataIndex: "prazo_conclusao",
      key: "prazo_conclusao",
      sorter: (a: any, b: any) => {
        const dateA = a.prazo_conclusao
          ? new Date(a.prazo_conclusao).getTime()
          : Infinity;
        const dateB = b.prazo_conclusao
          ? new Date(b.prazo_conclusao).getTime()
          : Infinity;
        return dateA - dateB;
      },
      render: (prazo: any) => {
        const today = moment().startOf("day");
        const prazoDate = moment(prazo).startOf("day");

        let color = "";
        if (prazoDate.isBefore(today)) {
          color = "red";
        } else if (prazoDate.isSame(today)) {
          color = "orange";
        } else {
          color = "green";
        }

        return (
          <span style={prazo ? { color, fontWeight: "bold" } : {}}>
            {prazo ? moment(new Date(prazo)).format("DD/MM/YYYY") : "-"}
          </span>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      filters: [
        { text: "Em andamento", value: "Em andamento" },
        { text: "Concluída", value: "Concluída" },
        { text: "Pendente", value: "Pendente" },
      ],
      onFilter: (value: any, record: any) => record.status === value,
      render: (status: string) => (
        <Tag
          color={
            status === "Em andamento"
              ? "blue"
              : status === "Concluída"
              ? "green"
              : "grey"
          }
        >
          {status}
        </Tag>
      ),
    },
    {
      title: "Data de criação",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a: any, b: any) =>
        new Date(a.created_at).getTime() - new Date(b.created_at).getTime(),
      render: (data: any) =>
        data ? moment(new Date(data)).format("DD/MM/YYYY") : "-",
    },
    {
      title: "Ações",
      key: "actions",
      render: (_: any, record: any) => (
        <Button
          type="link"
          icon={<EyeOutlined />}
          onClick={() => {
            moduloTask.setSelectedTask(record);
            handleShowModal();
          }}
        >
          Ver tarefa
        </Button>
      ),
    },
  ];
  const getStatusColor = (status: string) => {
    switch (status) {
      case "Em andamento":
        return {
          background: "#e6f7ff",
          border: "#1890ff",
          text: "#1890ff"
        };
      case "Concluída":
        return {
          background: "#f6ffed",
          border: "#52c41a",
          text: "#52c41a"
        };
      case "Pendente":
        return {
          background: "#fff7e6",
          border: "#fa8c16",
          text: "#fa8c16"
        };
      default:
        return {
          background: "#f5f5f5",
          border: "#d9d9d9",
          text: "#666666"
        };
    }
  };

  const renderCards = () => {
    const tasks = moduloTask.tasksCliente;

    let filteredTasks = tasks?.filter((t) => {
      return t.tipo === "titular" && !t.dependencia;
    });

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "16px", padding: "16px 0" }}>
        {filteredTasks?.map((task: any) => {
          const statusColor = getStatusColor(task.status);
          const assignedUser = usuarios?.find((u: any) => u._id === task.assignment_id);
          
          return (
            <Card
              key={task._id}
              style={{
                backgroundColor: statusColor.background,
                border: `1px solid ${statusColor.border}`,
                borderLeft: `4px solid ${statusColor.border}`,
                borderWidth: "0 0 0 3px",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                cursor: "pointer"
              }}
              className="task-card-hover"
              bodyStyle={{ padding: "12px", height: "100%", display: "flex", flexDirection: "column" }}
              onClick={() => {
                moduloTask.setSelectedTask(task);
                handleShowModal();
              }}
            >
              <div style={{ flex: 1 }}>
                <h4 style={{ 
                  margin: "0 0 8px 0", 
                  fontSize: "14px", 
                  fontWeight: "bold",
                  color: "#262626",
                  textDecoration: task.status === "Concluída" ? "line-through" : "none"
                }}>
                  {task.title}
                </h4>
                
                <div style={{ marginBottom: "8px" }}>
                  <span style={{ fontSize: "12px", color: "#8c8c8c" }}>Atribuição: </span>
                  <span style={{ fontSize: "12px", fontWeight: "500" }}>
                    {assignedUser?.name || "Não atribuído"}
                  </span>
                </div>

                <div style={{ marginBottom: "8px" }}>
                  <span style={{ fontSize: "12px", color: "#8c8c8c" }}>Prazo: </span>
                  <span style={{ 
                    fontSize: "12px", 
                    fontWeight: "500",
                    color: task.prazo_conclusao ? 
                      (moment(task.prazo_conclusao).isBefore(moment().startOf("day")) ? "red" :
                       moment(task.prazo_conclusao).isSame(moment().startOf("day")) ? "orange" : "green") : "#8c8c8c"
                  }}>
                    {task.prazo_conclusao ? moment(new Date(task.prazo_conclusao)).format("DD/MM/YYYY") : "Não definido"}
                  </span>
                </div>

                <div style={{ marginBottom: "12px" }}>
                  <span style={{ fontSize: "12px", color: "#8c8c8c" }}>Criado em: </span>
                  <span style={{ fontSize: "12px", fontWeight: "500" }}>
                    {task.created_at ? moment(new Date(task.created_at)).format("DD/MM/YYYY") : "-"}
                  </span>
                </div>
                <div style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                  <Tag color={statusColor.text} style={{ margin: 0, fontSize: "11px" }}>
                    {task.status}
                  </Tag>
                  <Button
                    type="link"
                    size="small"
                    icon={<EyeOutlined />}
                    onClick={() => {
                      moduloTask.setSelectedTask(task);
                      handleShowModal();
                    }}
                    style={{ padding: "4px 8px", fontSize: "12px" , marginLeft: "1rem", marginTop: "-0.25rem"}}
                  >
                    Ver tarefa
                  </Button>
                </div>
              </div>

            </Card>
          );
        })}
      </div>
    );
  };

  const renderTable = () => {
    const tasks = moduloTask.tasksCliente;

    let filteredTasks = tasks?.filter((t) => {
      return t.tipo === "titular" && !t.dependencia;
    });

    return <Table size="small" dataSource={filteredTasks} columns={columns} />;
  };

  const getClientOrder = (): string =>
    (
      clientes.find((cli: any) => cli._id === filtros.cliente)?.ordem || ""
    ).toString();

  const getQuestionarioIndex = (mapeamento: string | undefined): string => {
    const filteredQuestionarios = moduloMapeamento.questionarios?.filter(
      (quest: any) => quest.cliente_id === filtros.cliente
    );
    const foundQuestionario = moduloMapeamento.questionarios.find(
      (q: any) => q._id === mapeamento
    );

    // Check if foundQuestionario is not undefined before using it
    if (foundQuestionario !== undefined) {
      const questionarioIndex =
        filteredQuestionarios?.indexOf(foundQuestionario);
      return questionarioIndex !== -1 ? (questionarioIndex + 1).toString() : "";
    } else {
      return ""; // or handle the case when the questionario is not found
    }
  };

  const getAreaIndex = (areaId: string | undefined): string => {
    const filteredAreas: string[] | undefined = currentMapeamento?.areas;

    const areaIndex = filteredAreas?.findIndex((aId: string) => aId === areaId);

    return areaIndex !== undefined && areaIndex !== -1
      ? (areaIndex + 1).toString()
      : "";
  };

  const getCapituloIndex = (processo: string | undefined): string => {
    const filteredCapitulos = currentMapeamento?.capitulos;

    const capituloIndex = filteredCapitulos?.findIndex(
      (c: AreaType) => c?._id === processo
    );

    return capituloIndex !== undefined ? (capituloIndex + 1).toString() : "";
  };

  const getSubprocessoIndex = (subprocesso: string | undefined): string => {
    let subprocessoIndex = currentMapeamento?.capitulos.filter(
      (processo: any) => processo.dependencia === subprocesso
    );

    return subprocessoIndex !== undefined
      ? (subprocessoIndex + 1).toString()
      : "";
  };

  const getPerguntaIndex = (): string => {
    const perguntaIndex = moduloProcessos.perguntas
      ?.filter((p: any) =>
        moduloMapeamento.questionarios
          .find((q: any) => q._id === filtros.mapeamento)
          ?.perguntasRelacao?.find(
            (pergRel: any) =>
              pergRel.pergunta_id === p._id &&
              pergRel.capitulo_id === filtros.subprocesso
          )
      )
      .findIndex((item: any) => item._id === filtros.pergunta);

    return perguntaIndex !== undefined ? perguntaIndex.toString() : "";
  };

  const handleFormChange = (changedValues: any, allValues: any) => {
    // Lógica para limpar campos abaixo quando cliente é alterado
    if ("cliente" in changedValues) {
      setFiltros({
        cliente: changedValues["cliente"],
      });
      form.resetFields([
        "mapeamento",
        "area",
        "processo",
        "subprocesso",
        "pergunta",
      ]);
    }
    // Lógica para limpar campos abaixo quando mapeamento é alterado
    if ("mapeamento" in changedValues) {
      setFiltros((prev: any) => ({
        cliente: prev.cliente,
        mapeamento: changedValues["mapeamento"],
      }));
      form.resetFields(["area", "processo", "subprocesso", "pergunta"]);
    }

    // Lógica para limpar campos abaixo quando área é alterada
    if ("area" in changedValues) {
      setFiltros((prev: any) => ({
        cliente: prev.cliente,
        mapeamento: prev.mapeamento,
        area: changedValues["area"],
      }));
      form.resetFields(["processo", "subprocesso", "pergunta"]);
    }

    // Lógica para limpar campos abaixo quando processo é alterado
    if ("processo" in changedValues) {
      setFiltros((prev: any) => ({
        cliente: prev.cliente,
        mapeamento: prev.mapeamento,
        area: prev.area,
        processo: changedValues["processo"],
      }));
      form.resetFields(["subprocesso", "pergunta"]);
    }

    // Lógica para limpar campos abaixo quando processo é alterado
    if ("subprocesso" in changedValues) {
      setFiltros((prev: any) => ({
        cliente: prev.cliente,
        mapeamento: prev.mapeamento,
        area: prev.area,
        processo: prev.processo,
        subprocesso: changedValues["subprocesso"],
      }));
      form.resetFields(["pergunta"]);
    }
  };

  interface IconeRiscoProps {
    value: any;
    text: any;
  }

  const IconeRisco: React.FC<IconeRiscoProps> = ({ value, text }) => {
    // ICONES:
    const extremo = (
      <Danger
        size="16"
        color="red"
        style={{ cursor: "pointer", marginLeft: "0.5rem" }}
      />
    );

    const baixo = (
      <CheckCircleOutlined
        style={{
          color: "green",
          cursor: "pointer",
          marginLeft: "0.5rem",
          fontSize: 16,
        }}
      />
    );

    const alto = (
      <Danger
        size="16"
        color="#fc7600"
        style={{ cursor: "pointer", marginLeft: "0.5rem" }}
      />
    );

    const medio = (
      <Danger
        style={{ cursor: "pointer", marginLeft: "0.5rem" }}
        size="16"
        color="#fce700"
      />
    );

    const getIconByScore = (score: number) => {
      if (score >= 0.4) return extremo;
      if (score >= 0.3) return alto;
      if (score >= 0.2) return medio;
      return baixo;
    };

    const getScore = (value: any) => {
      // Pega o riscoData do titular atual
      const riscoData = Object.values(analiseRisco)[0];

      if (Array.isArray(value)) {
        // Se for array, pega a maior nota entre todos os valores
        const notas = value.map((v) => {
          const nota = riscoData?.analiseRiscoTitular?.notasPorItem[v];
          return nota || 0.1;
        });
        const maiorNota = Math.max(...notas);
        return maiorNota;
      }

      // Se não for array, retorna a nota do valor único
      const nota = riscoData?.analiseRiscoTitular?.notasPorItem[value];
      return nota || 0.1;
    };

    const score = getScore(value);
    const icon = getIconByScore(score);

    return (
      <div className="d-flex a-c risco-pop">
        {text}
        {icon}
      </div>
    );
  };

  const Titulares: React.FC<any> = () => {
    const processos = currentMapeamento?.capitulos?.find(
      (processo: any) =>
        processo?._id ===
        (filtros?.subprocesso ? filtros?.subprocesso : filtros?.processo)
    );

    const titulares = moduloMapeamento?.currentTitulares?.filter(
      (titular) => titular.relacao_id === processos?.questionarioCapitulo?._id
    );

    if (titulares && titulares.length > 0) {
      const defaultActiveKeys = titulares.map((titular: any) => titular._id);

      return (
        <div>
          {titulares.map((titular: Titular, index: number) => {
            const riscoData = titular._id
              ? analiseRisco[String(titular._id)]
              : null;

            return (
              <div key={titular._id}>
                <div>
                  <h4 style={{ color: "#5F29CC", marginBottom: "1rem" }}>
                    Análise de Risco:
                  </h4>
                  {riscoData && (
                    <Row gutter={[16, 16]}>
                      <Col span={8}>
                        <Card type="inner" title="Nível de Impacto">
                          <Space direction="vertical" style={{ width: "100%" }}>
                            <Progress
                              percent={
                                riscoData.analiseRiscoTitular?.risco * 100
                              }
                              status={
                                riscoData.analiseRiscoTitular?.nivelRisco ===
                                "Alto"
                                  ? "exception"
                                  : riscoData.analiseRiscoTitular
                                      ?.nivelRisco === "Médio"
                                  ? "active"
                                  : "success"
                              }
                              format={(percent) => (
                                <Tag
                                  color={
                                    riscoData.analiseRiscoTitular
                                      ?.nivelRisco === "Alto"
                                      ? "red"
                                      : riscoData.analiseRiscoTitular
                                          ?.nivelRisco === "Médio"
                                      ? "orange"
                                      : "green"
                                  }
                                >
                                  {riscoData.analiseRiscoTitular?.nivelRisco}
                                </Tag>
                              )}
                            />
                            <Row gutter={16}>
                              <Col span={12}>
                                <Statistic
                                  title="Fatores"
                                  value={
                                    riscoData.analiseRiscoTitular
                                      ?.quantidadeFatores
                                  }
                                />
                              </Col>
                              <Col span={12}>
                                <Statistic
                                  title="Risco"
                                  value={`${(
                                    riscoData?.analiseRiscoTitular?.risco * 100
                                  ).toFixed(2)}%`}
                                />
                              </Col>
                            </Row>
                          </Space>
                        </Card>
                      </Col>

                      <Col span={8}>
                        <Card
                          type="inner"
                          title="Análise do Questionário (Probabilidade)"
                        >
                          <Row gutter={16}>
                            <Col span={12}>
                              <Statistic
                                title="Respostas"
                                value={
                                  riscoData.analiseRespostasQuestionario
                                    ?.totalRespostas
                                }
                              />
                            </Col>
                            <Col span={12}>
                              <Statistic
                                title="Probabilidade"
                                value={`${(
                                  riscoData?.analiseRespostasQuestionario
                                    ?.media * 100
                                ).toFixed(0)}%`}
                                precision={2}
                                valueStyle={{
                                  color:
                                    riscoData.analiseRespostasQuestionario
                                      ?.media > 0.5
                                      ? "#cf1322"
                                      : riscoData.analiseRespostasQuestionario
                                          ?.media > 0.3
                                      ? "#faad14"
                                      : "#3f8600",
                                }}
                              />
                            </Col>
                          </Row>
                          <Progress
                            percent={
                              riscoData.analiseRespostasQuestionario?.media *
                              100
                            }
                            status={
                              riscoData.analiseRespostasQuestionario?.media >
                              0.5
                                ? "exception"
                                : riscoData.analiseRespostasQuestionario
                                    ?.media > 0.3
                                ? "active"
                                : "success"
                            }
                            style={{ marginTop: 16 }}
                          />
                        </Card>
                      </Col>

                      <Col span={8}>
                        <Card
                          type="inner"
                          title="Risco (Impacto x Probabilidade)"
                        >
                          <Row gutter={16}>
                            <Col span={24}>
                              <Statistic
                                title="Risco Calculado"
                                value={
                                  isNaN(
                                    riscoData.analiseRiscoTitular?.risco *
                                      riscoData.analiseRespostasQuestionario
                                        ?.media
                                  )
                                    ? "Dados insuficientes"
                                    : 
                                     `${(
                                        (riscoData.analiseRiscoTitular?.risco *
                                          riscoData.analiseRespostasQuestionario
                                            ?.media) * 100
                                      ).toFixed(2)}%`
                                }
                                precision={4}
                                valueStyle={{
                                  color:
                                    riscoData.analiseRiscoTitular?.risco *
                                      riscoData.analiseRespostasQuestionario
                                        ?.media >
                                    0.25
                                      ? "#cf1322"
                                      : riscoData.analiseRiscoTitular?.risco *
                                          riscoData.analiseRespostasQuestionario
                                            ?.media >
                                        0.15
                                      ? "#faad14"
                                      : "#3f8600",
                                }}
                              />
                            </Col>
                          </Row>
                          <Progress
                            percent={
                              riscoData.analiseRiscoTitular?.risco *
                              riscoData.analiseRespostasQuestionario?.media *
                              100
                            }
                            status={
                              riscoData.analiseRiscoTitular?.risco *
                                riscoData.analiseRespostasQuestionario?.media >
                              0.25
                                ? "exception"
                                : riscoData.analiseRiscoTitular?.risco *
                                    riscoData.analiseRespostasQuestionario
                                      ?.media >
                                  0.15
                                ? "active"
                                : "success"
                            }
                            format={(percent) => (
                              <Tag
                                color={
                                  riscoData.analiseRiscoTitular?.risco *
                                    riscoData.analiseRespostasQuestionario
                                      ?.media >
                                  0.25
                                    ? "red"
                                    : riscoData.analiseRiscoTitular?.risco *
                                        riscoData.analiseRespostasQuestionario
                                          ?.media >
                                      0.15
                                    ? "orange"
                                    : "green"
                                }
                              >
                                {riscoData.analiseRiscoTitular?.risco *
                                  riscoData.analiseRespostasQuestionario
                                    ?.media >
                                0.25
                                  ? "Alto"
                                  : riscoData.analiseRiscoTitular?.risco *
                                      riscoData.analiseRespostasQuestionario
                                        ?.media >
                                    0.15
                                  ? "Médio"
                                  : "Baixo"}
                              </Tag>
                            )}
                            style={{ marginTop: 16 }}
                          />
                        </Card>
                      </Col>
                    </Row>
                  )}
                </div>
                <br />
                <Collapse
                  className="collapse_titular"
                  size="large"
                  bordered={false}
                  defaultActiveKey={defaultActiveKeys}
                  items={[
                    {
                      label: (
                        <h5 style={{ color: "#5F29CC", marginTop: "-2.5px" }}>
                          <span style={{ color: "#5F29CC" }}>
                            {titular.categoria?.toUpperCase()}
                          </span>
                        </h5>
                      ),
                      key: titular._id,
                      children: (
                        <div className="grid-container">
                          {/* Coleta */}
                          <Collapse
                            className="collapse_etapas"
                            defaultActiveKey={"1-coleta"}
                            items={[
                              {
                                key: "1-coleta",
                                label: (
                                  <p
                                    style={{
                                      color: "#fff",
                                    }}
                                  >
                                    Coleta
                                  </p>
                                ),
                                children: (
                                  <div>
                                    <Descriptions
                                      column={1}
                                      layout="vertical"
                                      labelStyle={{
                                        fontWeight: "bold",
                                        color: "#000",
                                      }}
                                    >
                                      <Descriptions.Item label="Número Estimado">
                                        <IconeRisco
                                          value={titular.quantidade}
                                          text={
                                            titular.quantidade + " Titulares"
                                          }
                                        />
                                      </Descriptions.Item>
                                      <Descriptions.Item label="Faixa etária">
                                        <IconeRisco
                                          value={titular.faixa_etaria}
                                          text={titular.faixa_etaria?.join(
                                            " | "
                                          )}
                                        />
                                      </Descriptions.Item>
                                      <Descriptions.Item label="Dados Pessoais comuns">
                                        {titular.dados
                                          ?.map(
                                            (dado: any) =>
                                              moduloMapeamento.dados
                                                ?.filter(
                                                  (d: any) =>
                                                    d.tipo !== "sensivel"
                                                )
                                                ?.find(
                                                  (d: any) =>
                                                    d._id === dado.dado_id
                                                )?.nome
                                          )
                                          ?.join(" | ") || "-"}
                                      </Descriptions.Item>
                                      <Descriptions.Item label="Dados Pessoais sensíveis">
                                        {titular.dados
                                          ?.filter(
                                            (d: any) => d.tipo === "sensivel"
                                          )
                                          ?.map(
                                            (dado: any) =>
                                              moduloMapeamento.dados?.find(
                                                (d: any) =>
                                                  d._id === dado.dado_id
                                              )?.nome
                                          )
                                          ?.join(" | ") || "-"}
                                      </Descriptions.Item>
                                      <Descriptions.Item label="Origem dos Dados">
                                        <IconeRisco
                                          value={titular.dados}
                                          text={Array.from(
                                            new Set(
                                              titular.dados?.flatMap(
                                                (dado: any) => dado.origem
                                              )
                                            )
                                          )?.join(" | ")}
                                        />
                                      </Descriptions.Item>
                                      {titular.finalidade_coleta && (
                                        <Descriptions.Item label="Finalidade e Necessidade">
                                          {titular.finalidade_coleta}
                                        </Descriptions.Item>
                                      )}
                                      {titular.medidas_coleta && (
                                        <Descriptions.Item label="Medidas de Segurança">
                                          {titular.medidas_coleta}
                                        </Descriptions.Item>
                                      )}
                                      {titular.obs_coleta && (
                                        <Descriptions.Item label="Observações">
                                          {titular.obs_coleta}
                                        </Descriptions.Item>
                                      )}
                                    </Descriptions>
                                  </div>
                                ),
                              },
                            ]}
                          />

                          {/* Processamento */}
                          <Collapse
                            className="collapse_etapas"
                            defaultActiveKey={"1-processamento"}
                            items={[
                              {
                                key: "1-processamento",
                                label: (
                                  <p
                                    style={{
                                      color: "#fff",
                                    }}
                                  >
                                    Processamento
                                  </p>
                                ),
                                children: (
                                  <div>
                                    <Descriptions
                                      layout="vertical"
                                      labelStyle={{
                                        fontWeight: "bold",
                                        color: "#000",
                                      }}
                                      column={1}
                                    >
                                      <Descriptions.Item label="Frequência">
                                        <IconeRisco
                                          value={{
                                            tipo: "frequencia",
                                            dados: titular.dados,
                                          }}
                                          text={Array.from(
                                            new Set(
                                              titular.dados
                                                ?.flatMap(
                                                  (dado: any) => dado.frequencia
                                                )
                                                .filter((f: any) => f)
                                            )
                                          )?.join(" | ")}
                                        />
                                      </Descriptions.Item>
                                      <Descriptions.Item label="Bases Legais">
                                        {(titular.dados &&
                                          Array.from(
                                            new Set([
                                              ...titular.dados?.flatMap(
                                                (dado: any) =>
                                                  dado.bases_legais_comuns
                                              ),
                                              ...titular.dados?.flatMap(
                                                (dado: any) =>
                                                  dado.bases_legais_sensiveis
                                              ),
                                            ])
                                          )
                                            ?.filter((i: any) => i)
                                            ?.join(" | ")) ||
                                          "-"}
                                      </Descriptions.Item>
                                      {titular.finalidade_processamento && (
                                        <Descriptions.Item label="Finalidade e Necessidade">
                                          {titular.finalidade_processamento}
                                        </Descriptions.Item>
                                      )}
                                      {titular.medidas_processamento && (
                                        <Descriptions.Item label="Medidas de Segurança">
                                          {titular.medidas_processamento}
                                        </Descriptions.Item>
                                      )}
                                      {titular.obs_processamento && (
                                        <Descriptions.Item label="Observações">
                                          {titular.obs_processamento}
                                        </Descriptions.Item>
                                      )}
                                    </Descriptions>
                                  </div>
                                ),
                              },
                            ]}
                          />

                          {/* Compartilhamento */}
                          <Collapse
                            className="collapse_etapas"
                            defaultActiveKey={"1-compartilhamento"}
                            items={[
                              {
                                key: "1-compartilhamento",
                                label: (
                                  <p
                                    style={{
                                      color: "#fff",
                                    }}
                                  >
                                    Compartilhamento
                                  </p>
                                ),
                                children: (
                                  <div>
                                    <Descriptions
                                      layout="vertical"
                                      column={1}
                                      labelStyle={{
                                        fontWeight: "bold",
                                        color: "#000",
                                      }}
                                    >
                                      <Descriptions.Item label="Departamentos">
                                        {Array.from(
                                          new Set(
                                            titular.dados?.flatMap(
                                              (dado: any) =>
                                                dado.areas_compartilhadas?.map(
                                                  (area: any) =>
                                                    moduloProcessos.areas?.find(
                                                      (a: any) =>
                                                        a._id === area.area_id
                                                    )?.description
                                                )
                                            )
                                          )
                                        ).join(" | ")}
                                      </Descriptions.Item>
                                      <Descriptions.Item label="Formas de compartilhamento">
                                        {Array.from(
                                          new Set(
                                            titular.dados?.flatMap(
                                              (dado: any) =>
                                                dado.areas_compartilhadas?.map(
                                                  (area: any) => area.forma
                                                )
                                            )
                                          )
                                        ).join(" | ")}
                                      </Descriptions.Item>
                                      <Descriptions.Item label="Externos">
                                        {Array.from(
                                          new Set(
                                            titular.dados?.flatMap(
                                              (dado: any) =>
                                                dado.externos
                                                  ?.map(
                                                    (ext: any) =>
                                                      fornecedores?.find(
                                                        (f: any) =>
                                                          f._id ===
                                                          ext.fornecedor_id
                                                      )?.nome +
                                                      ": " +
                                                      ext.forma
                                                  )
                                                  .join(" | ")
                                            )
                                          )
                                        ).join(" | ") || "-"}
                                      </Descriptions.Item>
                                      <Descriptions.Item label="Transferência Internacional">
                                        <IconeRisco
                                          value={{
                                            tipo: "paises",
                                            dados: titular.dados,
                                          }}
                                          text={
                                            titular.dados?.find(
                                              (dado: any) => dado.paises
                                            )
                                              ? titular.dados
                                                  .filter(
                                                    (dado: any) => dado.paises
                                                  )
                                                  .map(
                                                    (dado: any) => dado.paises
                                                  )
                                                  .join(" | ")
                                              : "Não"
                                          }
                                        />
                                      </Descriptions.Item>
                                      {titular.finalidade_compartilhamento && (
                                        <Descriptions.Item label="Finalidade e Necessidade">
                                          {titular.finalidade_compartilhamento}
                                        </Descriptions.Item>
                                      )}
                                      {titular.medidas_compartilhamento && (
                                        <Descriptions.Item label="Medidas de segurança">
                                          {titular.medidas_compartilhamento}
                                        </Descriptions.Item>
                                      )}
                                      {titular.obs_compartilhamento && (
                                        <Descriptions.Item label="Observações">
                                          {titular.obs_compartilhamento}
                                        </Descriptions.Item>
                                      )}
                                    </Descriptions>
                                  </div>
                                ),
                              },
                            ]}
                          />

                          {/* Armazenamento e retenção */}
                          <Collapse
                            className="collapse_etapas"
                            defaultActiveKey={"1-armazenamento"}
                            items={[
                              {
                                key: "1-armazenamento",
                                label: (
                                  <p
                                    style={{
                                      color: "#fff",
                                    }}
                                  >
                                    Armazenamento e retenção
                                  </p>
                                ),
                                children: (
                                  <div className="grid-item">
                                    <Descriptions
                                      layout="vertical"
                                      column={1}
                                      labelStyle={{
                                        fontWeight: "bold",
                                        color: "#000",
                                      }}
                                    >
                                      <Descriptions.Item label="Local do Armazenamento">
                                        {Array.from(
                                          new Set(
                                            titular.dados?.flatMap(
                                              (dado: any) =>
                                                dado.local
                                                  ?.map((local: any) => local)
                                                  .join(" | ")
                                            )
                                          )
                                        ).join(" | ")}
                                      </Descriptions.Item>
                                      <Descriptions.Item label="Prazo de guarda">
                                        {Array.from(
                                          new Set(
                                            titular.dados?.flatMap(
                                              (dado: any) => dado.prazo
                                            )
                                          )
                                        )?.join(" | ") || "Não definido"}
                                      </Descriptions.Item>
                                      {titular.finalidade_armazenamento && (
                                        <Descriptions.Item label="Finalidade e Necessidade">
                                          {titular.finalidade_armazenamento}
                                        </Descriptions.Item>
                                      )}
                                      {titular.medidas_armazenamento && (
                                        <Descriptions.Item label="Medidas de segurança">
                                          {titular.medidas_armazenamento}
                                        </Descriptions.Item>
                                      )}
                                      {titular.obs_armazenamento && (
                                        <Descriptions.Item label="Observações">
                                          {titular.obs_armazenamento}
                                        </Descriptions.Item>
                                      )}
                                    </Descriptions>
                                  </div>
                                ),
                              },
                            ]}
                          />
                        </div>
                      ),
                    },
                  ]}
                />
              </div>
            );
          })}
        </div>
      );
    } else {
      return (
        <Alert
          type="info"
          message="Nenhum titular encontrado, revise a seleção do processo."
          showIcon
        />
      );
    }
  };

  return (
    <div className="ficha">
      <BackHeader title="Ficha de processo" prevAction={backHeaderFunction} />
      {/* Filtros ficha */}
      {filtrosFeitos && <br />}
      {!filtrosFeitos && (
        <Form
          form={form}
          name="fichas"
          layout="vertical"
          onValuesChange={handleFormChange}
        >
          {!filtros?.cliente && (
            <Alert
              type="warning"
              message="Selecione um cliente para visualizar!"
              showIcon
            />
          )}
          <Space wrap>
            {filtros?.cliente && (
              <>
                {moduloMapeamento.questionarios?.filter(
                  (quest: any) => quest.nome === "Assessment Process"
                )?.length > 1 && (
                  <Form.Item name="mapeamento" label="Ficha">
                    <Select
                      loading={
                        moduloMapeamento.questionarios?.filter(
                          (quest: any) => quest.cliente_id === filtros.cliente
                        )?.[0]
                          ? false
                          : true
                      }
                      disabled={
                        moduloMapeamento.questionarios?.filter(
                          (quest: any) => quest.cliente_id === filtros.cliente
                        )?.[0]
                          ? false
                          : true
                      }
                      value={filtros?.mapeamento}
                      style={{ width: "24rem" }}
                      placeholder="Selecione um mapeamento"
                      options={moduloMapeamento.questionarios
                        ?.filter(
                          (quest: any) => quest.nome === "Assessment Process"
                        )
                        ?.filter(
                          (quest: any) => quest.cliente_id === filtros.cliente
                        )
                        ?.sort(
                          (a: any, b: any) =>
                            new Date(b.created_at).getTime() -
                            new Date(a.created_at).getTime()
                        )
                        .map((quest: any) => {
                          return {
                            key: quest._id,
                            value: quest._id,
                            label: (
                              <Tooltip title={quest.nome}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <p
                                    style={{
                                      width: "200px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {quest.nome.length > 25
                                      ? quest.nome.substring(0, 25) + "..."
                                      : quest.nome}
                                  </p>
                                  <Tag
                                    color="magenta"
                                    style={{ marginLeft: "1rem" }}
                                  >
                                    {moment(new Date(quest.created_at)).format(
                                      "DD/MM/YYYY HH:mm"
                                    )}
                                  </Tag>
                                </div>
                              </Tooltip>
                            ),
                          };
                        })}
                    />
                  </Form.Item>
                )}
              </>
            )}
            {filtros?.mapeamento && (
              <>
                {moduloMapeamento.questionarios?.filter(
                  (quest: any) => quest.nome === "Assessment Process"
                )?.length > 1 && <RightOutlined className="ficha__rightIcon" />}

                {/* {moduloProcessos?.areas?.length !== 1 &&
                  currentMapeamento?.areas?.length !== 1 && ( */}
                    <Form.Item name="area" label="Área">
                      <Select
                        value={filtros?.area}
                        style={{ minWidth: 300 }}
                        placeholder="Selecione uma área"
                        options={currentMapeamento?.areas
                          ?.filter((areaId: string) =>
                            moduloProcessos.areas?.find((a) => areaId === a._id)
                          )
                          ?.map((areaId: any) => {
                            return {
                              key: areaId,
                              value: areaId,
                              label: moduloProcessos.areas?.find(
                                (a) => areaId === a._id
                              )?.description,
                            };
                          })}
                      />
                    </Form.Item>
                  {/* // )} */}
              </>
            )}

            {filtros?.area && (
              <>
                {moduloProcessos?.areas?.length !== 1 &&
                  currentMapeamento?.areas?.length !== 1 && (
                    <RightOutlined className="ficha__rightIcon" />
                  )}
                {/* {currentMapeamento?.capitulos?.filter(
                  (proc: any) => !proc.dependencia
                )?.length !== 1 && ( */}
                <Form.Item name="processo" label="Processo">
                  <Select
                    value={filtros?.processo}
                    placeholder="Selecione o processo"
                    style={{ minWidth: 300 }}
                    options={currentMapeamento?.capitulos
                      ?.filter(
                        (cap: any) =>
                          cap.tags?.includes(filtros.area) && !cap.dependencia
                      )
                      ?.map((processo: any) => {
                        return {
                          key: processo._id,
                          value: processo._id,
                          label: processo.description,
                        };
                      })}
                  />
                </Form.Item>
                {/* // )} */}
              </>
            )}
            {filtros?.processo &&
              currentMapeamento?.capitulos?.filter(
                (cap: any) => cap.dependencia === filtros.processo
              )?.[0] && (
                <>
                  {currentMapeamento?.capitulos?.filter(
                    (proc: any) => !proc.dependencia
                  )?.length !== 1 && (
                    <RightOutlined className="ficha__rightIcon" />
                  )}

                  <Form.Item name="subprocesso" label="Subprocesso">
                    <Select
                      value={filtros?.subprocesso}
                      style={{ width: 240 }}
                      options={currentMapeamento?.capitulos
                        ?.filter(
                          (cap: any) => cap.dependencia === filtros.processo
                        )
                        ?.map((processo: any) => {
                          return {
                            key: processo._id,
                            value: processo._id,
                            label: processo.description,
                          };
                        })
                        ?.reduce((acc: any[], current: any) => {
                          // Verifica se já existe um objeto com a mesma key no acumulador
                          const exists = acc.find(
                            (item) => item.key === current.key
                          );

                          // Se não existir, adiciona o objeto ao acumulador
                          if (!exists) {
                            acc.push(current);
                          }

                          return acc;
                        }, [])}
                    />
                  </Form.Item>
                </>
              )}
          </Space>
        </Form>
      )}
      {filtros?.mapeamento && (
        <Tabs
          onChange={(key) => setActiveKey(key)}
          size="large"
          type="card"
          activeKey={activeKey}
          items={[
            {
              key: "1",
              label: "Ficha de processo",
              children: (
                <div style={{ background: "#fff", padding: 16 }}>
                  {/* imprimir */}
                  {filtros.processo && !loadingLogs && currentMapeamento ? (
                    <Tooltip title="Registro das Operações de Tratamento de Dados Pessoais">
                      <PdfDownload
                        title={"Imprimir ROT"}
                        content={
                          <RelatorioROT
                            logs={logs}
                            loadingLogs={loadingLogs}
                            filtros={filtros}
                            currentMapeamento={currentMapeamento}
                            codigoFicha={`${
                              filtros.cliente &&
                              clientes?.[0] &&
                              `${getClientOrder()}.`
                            }${
                              filtros.mapeamento &&
                              `${getQuestionarioIndex(filtros.mapeamento)}`
                            }${
                              filtros.area && `.${getAreaIndex(filtros.area)}`
                            }${
                              filtros.processo &&
                              `.${getCapituloIndex(filtros.processo)}`
                            }${
                              filtros.subprocesso &&
                              `.${getSubprocessoIndex(filtros.subprocesso)}`
                            }`}
                          />
                        }
                      />
                    </Tooltip>
                  ) : (
                    <Button
                      icon={<PrinterOutlined />}
                      type="primary"
                      loading={true}
                      disabled
                    >
                      Imprimir ROT
                    </Button>
                  )}
                  <br />
                  {/* Visualização ficha */}
                  {filtros.cliente && currentMapeamento && (
                    <div ref={printRef} className="print-container">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: " flex-end",
                        }}
                      >
                        <h2 style={{ color: "#5f29cc", fontWeight: "bold" }}>
                          {filtros.cliente &&
                            clientes?.[0] &&
                            `${getClientOrder()}.`}
                          {filtros.mapeamento &&
                            `${getQuestionarioIndex(filtros.mapeamento)}`}
                          {filtros.area && `.${getAreaIndex(filtros.area)}`}
                          {filtros.processo &&
                            `.${getCapituloIndex(filtros.processo)}`}
                          {filtros.subprocesso &&
                            `.${getSubprocessoIndex(filtros.subprocesso)}`}
                          {filtros.pergunta && `.${getPerguntaIndex()}`}
                        </h2>
                        <h2 style={{ fontSize: "1.2rem" }}>
                          {moment(
                            new Date(currentMapeamento?.updated_at)
                          ).format("DD/MM/YYYY")}
                        </h2>
                      </div>
                      <hr />
                      <br />
                      <h4 style={{ fontSize: "1.4rem", color: "#5F29CC" }}>
                        {
                          moduloMapeamento.ficha
                            ?.find((f: any) => f?._id === filtros?.mapeamento)
                            ?.areas?.find((a: any) => a?._id === filtros?.area)
                            ?.processos?.find(
                              (processo: any) =>
                                processo?._id ===
                                (filtros?.subprocesso
                                  ? filtros?.subprocesso
                                  : filtros?.processo)
                            )?.description
                        }
                      </h4>

                      <Row gutter={24}>
                        <Col span={12}>
                          {/* Dados da empresa */}
                          {clientes?.[0] && (
                            <ContainerFicha>
                              <p style={{ fontSize: 18 }}>
                                <b>Empresa: </b>
                                {
                                  clientes?.find(
                                    (cli: any) => cli._id === filtros?.cliente
                                  )?.razao_social
                                }
                              </p>
                              <p style={{ fontSize: 18, marginTop: "1rem" }}>
                                <b>CNPJ: </b>
                                {
                                  clientes?.find(
                                    (cli: any) => cli._id === filtros?.cliente
                                  )?.cnpj
                                }
                              </p>
                            </ContainerFicha>
                          )}
                        </Col>
                        <Col span={12}>
                          {/* Responsável e Local */}
                          {filtros.processo && (
                            <ContainerFicha>
                              <p style={{ fontSize: 18 }}>
                                <b>Responsável pelo processo: </b>
                                {
                                  usuarios?.find(
                                    (usr: any) =>
                                      // usr.grupos.find(
                                      //   (g: any) => g.name === "Líder de processo"
                                      // ) &&
                                      usr.funcoesDetalhadas.find(
                                        (fd: any) =>
                                          fd.reference_model_id ===
                                          filtros.mapeamento
                                      ) &&
                                      usr.funcoesDetalhadas.find(
                                        (fd: any) =>
                                          fd.reference_model_id ===
                                            filtros.processo ||
                                          fd.reference_model_id ===
                                            moduloProcessos.capitulos?.find(
                                              (c) => c._id === filtros.processo
                                            )?.dependencia
                                      )
                                  )?.name
                                }
                              </p>
                              <p style={{ fontSize: 18, marginTop: "1rem" }}>
                                <b>Local: </b>
                                {currentMapeamento && filtros?.area && (
                                  <>
                                    {moduloProcessos.areas?.find(
                                      (a) => a._id === filtros.area
                                    ) &&
                                      moduloProcessos.capitulos?.find(
                                        (c) => c._id === filtros.processo
                                      ) && (
                                        <>
                                          {
                                            moduloProcessos.areas?.find(
                                              (a) => a._id === filtros.area
                                            )?.description
                                          }{" "}
                                          {">"}{" "}
                                          {
                                            moduloProcessos.capitulos?.find(
                                              (c) => c._id === filtros.processo
                                            )?.description
                                          }{" "}
                                          {">"}{" "}
                                          {moduloProcessos.capitulos?.find(
                                            (c) => c._id === filtros.subprocesso
                                          ) &&
                                            moduloProcessos.capitulos?.find(
                                              (c) =>
                                                c._id === filtros.subprocesso
                                            )?.description}
                                        </>
                                      )}
                                  </>
                                )}
                              </p>
                            </ContainerFicha>
                          )}
                        </Col>
                      </Row>
                      <br />
                      <br />
                      {filtros.processo && (
                        <ContainerFicha>
                          <h2
                            style={{
                              pageBreakBefore: "always",
                            }}
                          >
                            Processo de tratamento de dados pessoais
                          </h2>
                          <hr />
                          <Titulares />
                        </ContainerFicha>
                      )}
                      <br />
                      <br />

                      {/* historico */}
                      <ContainerFicha>
                        <h2
                          style={{
                            pageBreakBefore: "always",
                          }}
                        >
                          Histórico
                        </h2>
                        <hr />
                        <TimelineGeral
                          logs={logs}
                          mapeamentoId={filtros.mapeamento}
                          loadingLogs={loadingLogs}
                        />
                      </ContainerFicha>

                      <style>{`
                      @media print {
                        .print-container {
                          margin: 1cm; /* Adicione as margens desejadas aqui */
                        }
                      }
                    `}</style>
                    </div>
                  )}
                </div>
              ),
            },
            {
              key: "2",
              label: "Plano de Ação",
              children: (
                <div style={{ background: "#fff", padding: 16, borderRadius: "0 0 8px 8px" }}>
                  {renderCards()}
                  <Task setShowModal={setShowModal} showModal={showModal} />
                </div>
              ),
            },
            // {
            //   key: "3",
            //   label: "Visão em árvore",
            //   children: (
            //     <div>
            //       <TreeHierarchyGraph
            //         treeData={[
            //           {
            //             name: "Nome da empresa",
            //             children: [
            //               {
            //                 name: "Tecnologia da Informação",
            //                 children: [
            //                   {
            //                     name: "Processo 1",
            //                     attributes: {
            //                       Department: "Production",
            //                       isFullTime: true,
            //                       weeklyHours: 80,
            //                       teste: () => <h1>teste</h1>,
            //                     },
            //                   },

            //                   {
            //                     name: "Processo 2",
            //                   },
            //                 ],
            //               },
            //               {
            //                 name: "Recursos Humanos",
            //                 children: [
            //                   {
            //                     name: "Processo 1",
            //                   },
            //                   {
            //                     name: "Processo 2",
            //                     children: [
            //                       {
            //                         name: "Subprocesso 1",
            //                       },
            //                       {
            //                         name: "Subprocesso 2",
            //                       },
            //                     ],
            //                   },
            //                 ],
            //               },
            //             ],
            //           },
            //         ]}
            //       />
            //     </div>
            //   ),
            // },
          ]}
        />
      )}
      {!moduloMapeamento.questionarios?.find(
        (quest: any) => quest.nome === "Assessment Process"
      ) && (
        <Alert type="warning" message="Nenhum mapeamento aplicado" showIcon />
      )}
    </div>
  );
};

export default Fichas;
